import React from 'react';

export const HeaderChip = ({
    delegacion,
    labelPlan
}) => {
    return (
        <div className='header-chip-container'>
        <div className='header-chip'>
            <strong>Delegación: </strong>
            <span>{delegacion} </span>
            <strong className='header-chip-plan-title'>Plan: </strong>
            <span>{labelPlan}</span>
        </div>
        </div>
    )
}